export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9794.4cb26cc4.jpg";